import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import deliveryAPI from '../../api/delivery';
import { Types, Creators as DeliveryCreators } from '../../reducers/delivery';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import { getToken } from '../../utils/getToken';

function* thirdsDeleteRequest({ sellerId, thirdId }) {
  try {
    const { cart, customer, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const cartId = cart.id || customer.cartId || getCartId();
    const token = (yield select(getToken)) || customer.token;

    yield call(deliveryAPI.removeThirdParty, cartId, thirdId, token, siteId);

    yield put(DeliveryCreators.thirdsDeleteSuccess(sellerId));
  } catch (error) {
    yield put(DeliveryCreators.thirdsDeleteFailed(sellerId, formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.THIRDS_DELETE_REQUEST, thirdsDeleteRequest);
}
